import React, { useEffect } from "react";
import { connect } from "react-redux";
import PageHeader from "../../../shared/components/PageHeader";
import { Container, Row } from "reactstrap";
import RecipientTable from "./components/RecipientTable";
import { getRecipients } from "../actions/disbursement.actions";

const DisbursementRecipientList = (props) => {
  const { dispatch, recipientList } = props;
  const loadDisbursementRecipients = (requestParams) => {
    dispatch(getRecipients({...requestParams, batchId: props.match.params.id }))
  };

  useEffect(() => {
    if (props.match.params.id) {
    dispatch(getRecipients({batchId: props.match.params.id, pageNum: 1, pageSize: 10, searchKey:""  }))
    }
  }, [dispatch, props.match.params.id]);

  return (
    <Container>
      <PageHeader
        header="Recipient List"
        subheader="View all Recipients and their status"
      />
      <Row>
        <RecipientTable
          dataState={recipientList}
          fetchData={loadDisbursementRecipients}
        />
      </Row>
    </Container>
  );
};

export default connect((state) => ({
  recipientList: state.winnerDisbursement
}))(DisbursementRecipientList);
